/**
 * This utility is used for generating font-face CSS code for a specified theme.
 */
export default class FontFace {
    /**
     * Returns font faces.
     *
     * @param theme Theme.
     * @returns Css code.
     */
    static getFontFaces(theme) {
        return theme.fontFace.sources
            .map((source) => {
            const properties = [
                `font-family: ${theme.fontFace.family};`,
                `src: url('${source.formats.woff2.url}') format('${source.formats.woff2.format}'), 
					url('${source.formats.woff.url}') format('${source.formats.woff.format}'), 
					url('${source.formats.ttf.url}') format('${source.formats.ttf.format}');`,
                `font-display: swap;`
            ];
            if (source.weight) {
                properties.push(`font-weight: ${source.weight};`);
            }
            if (source.style) {
                properties.push(`font-style: ${source.style};`);
            }
            return `
				@font-face {
					${properties.join('\n')}
				}
			`;
        })
            .join('\n');
    }
}
//# sourceMappingURL=FontFace.js.map